const steps = [
  {
    number: "01",
    icon: "ri-computer-line",
    title: "Start Your Order Online",
    description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Caltech office, JPL lab, or Arcadia home.",
  },
  {
    number: "02",
    icon: "ri-file-list-3-line",
    title: "We Confirm & Send Your Checklist",
    description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation.",
  },
  {
    number: "03",
    icon: "ri-send-plane-line",
    title: "Ship Your Documents Overnight",
    description: "Send your documents using an overnight shipping option. Most Pasadena clients ship from home or a nearby FedEx/UPS — no office visit needed.",
  },
  {
    number: "04",
    icon: "ri-building-2-line",
    title: "We Submit Through Reserved Access",
    description: "We submit through our reserved passport agency availability — so you do not have to drive to the LA Passport Agency or hope an appointment opens up.",
  },
  {
    number: "05",
    icon: "ri-passport-line",
    title: "Your Passport Is Completed",
    description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty.",
  },
];

export default function PasadenaHowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Simple Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            How Our Expedited Process Works
          </h2>
          <p className="text-white/60 max-w-xl mx-auto text-base">
            From start to finish, we make getting an expedited passport in Pasadena as simple as possible — with the efficiency and reliability researchers, executives, and families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-[#F6C344]/20 mx-24"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((step, i) => (
              <div key={i} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-full bg-[#F6C344] mb-5 flex-shrink-0">
                  <div className="flex flex-col items-center">
                    <i className={`${step.icon} text-[#1A365D] text-xl`}></i>
                    <span className="text-[#1A365D] text-xs font-bold leading-none mt-0.5">{step.number}</span>
                  </div>
                </div>
                <h3 className="font-bold text-white text-sm mb-2 leading-snug">{step.title}</h3>
                <p className="text-white/50 text-xs leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-price-tag-3-line text-[#F6C344] text-base"></i>
            <span>Best Price Guarantee</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-[#F6C344] text-base"></i>
            <span>Registered State Dept. Courier</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-award-line text-[#F6C344] text-base"></i>
            <span>A+ BBB Rating</span>
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-10 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-white/40 text-xs mt-4">
            Most Pasadena travelers start online and ship documents overnight — no office visit required for most services.
          </p>
        </div>
      </div>
    </section>
  );
}